module.exports = __webpack_public_path__ + "img/zhaunyepeixun_1.1bcdf3eb.jpg";